<template>
  <div>
    <blocking-loader :show="loaded === false">Przygotowywanie Formularza</blocking-loader>
    <div v-if="modelLoaded && loaded">
      <CommonForm
        :rawSchemas="rawSchemas"
        :model="model"
        :id="`main-info`"
        :rules="rules"
        :schemaType="`appraisal`"
        @saveField="handleSaveField"
        @addCollectionItem="handleAddCollectionItem"
        @removeCollectionItem="handleRemoveCollectionItem"
      >
      </CommonForm>
    </div>
  </div>

</template>
<script>
import BlockingLoader from '@/components/share/BlockingLoader.vue'
// import Tabs from '@/components/share/tabs/Tabs.vue'
// import RealEstate from '../form/forms/realEstate.vue'
import {
  FORM_EVENT_ADD_COLLECTION_ITEM,
  FORM_EVENT_REMOVE_COLLECTION_ITEM,
  FORM_EVENT_SAVE_FIELD
} from '../form/utils/formEventsConstants.js'
import CommonForm from '../form/forms/CommonForm.vue'
// import realEstateKindMixin from '../summary/realEstateKindMixin.js'

export default {
  components: {
    CommonForm,
    BlockingLoader,
    // RealEstate,
    // Tabs
  },
  // mixins: [realEstateKindMixin],
  props: {
    model: {},
    rawSchemas: {},
    rules: {},
    categoryGroup: {type: String, required: true},
    service: {},
    addLandRegisterCaller: {},
    schema: {},
    rulesTemp: {},
    modelLoaded: {}
  },
  data () {
    return {
      schemaTabs: [],
      loaded: false,
      activeTabIndex: 0,
      reloading: false
    }
  },
  watch: {
    rules() {
      this.reloading = false
    }
  },
  async mounted () {
    this.loaded = true
  },
  methods: {
    handleSaveField (data) {
      this.$emit(FORM_EVENT_SAVE_FIELD, data)
    },
    handleAddCollectionItem (e) {
      this.$emit(FORM_EVENT_ADD_COLLECTION_ITEM, e)
    },
    handleRemoveCollectionItem (e) {
      this.$emit(FORM_EVENT_REMOVE_COLLECTION_ITEM, e)
    }
  }
}
</script>
<style>
</style>
